import { useAuth } from "@/hooks/use-auth";
import { Navigate, Outlet } from "@tanstack/react-router";

export function AdminProtectedRoute({ children }: { children?: React.ReactNode }) {
  const { profile, authState } = useAuth();

  if (authState === 'carregando') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F9F5]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-500 font-medium">Verificando permissões...</p>
        </div>
      </div>
    );
  }

  // Se autenticado mas perfil ainda não chegou, espera
  if (authState === 'autenticado' && !profile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F7F9F5]">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-gray-500 font-medium">Carregando perfil...</p>
        </div>
      </div>
    );
  }

  const isAdmin = profile?.role === "admin" || profile?.role === "super_admin";

  if (authState === 'anonimo' || !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children || <Outlet />}</>;
}

